import { render, staticRenderFns } from "@/components/Layout/Comentarios_detalle/Editar_comentarios_detalle/Editar_comentarios_detalle.html?vue&type=template&id=24baedf8&scoped=true&"
import script from "@/components/Layout/Comentarios_detalle/Editar_comentarios_detalle/Editar_comentarios_detalle.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Comentarios_detalle/Editar_comentarios_detalle/Editar_comentarios_detalle.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Comentarios_detalle/Editar_comentarios_detalle/Editar_comentarios_detalle.css?vue&type=style&index=0&id=24baedf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24baedf8",
  null
  
)

export default component.exports